module.exports = __webpack_public_path__ + "static/media/icon_87.18e82a7b.svg";